var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_751)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5325 13.1563C30.8674 13.4912 31.1087 13.9079 31.2324 14.3651C31.9447 17.2322 31.7801 21.7604 31.2462 24.7381C31.1225 25.1953 30.8812 25.612 30.5464 25.9469C30.2115 26.2818 29.7947 26.5231 29.3376 26.6468C27.6641 27.1032 20.9285 27.1032 20.9285 27.1032C20.9285 27.1032 14.1929 27.1032 12.5194 26.6468C12.0623 26.5231 11.6455 26.2818 11.3106 25.9469C10.9758 25.612 10.7345 25.1953 10.6108 24.7381C9.89432 21.8835 10.0907 17.3525 10.5969 14.3789C10.7206 13.9217 10.9619 13.505 11.2968 13.1701C11.6317 12.8352 12.0484 12.5939 12.5056 12.4702C14.1791 12.0138 20.9147 12 20.9147 12C20.9147 12 27.6502 12 29.3238 12.4564C29.7809 12.5801 30.1977 12.8214 30.5325 13.1563ZM24.3588 19.5517L18.7712 22.7881V16.3153L24.3588 19.5517Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_751"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.8571,
    height: 16,
    transform: "translate(9 12)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterYoutube);
export default __webpack_public_path__ + "static/media/footerYoutube.49f0f6adbcd1145f53190b0220fd49b3.svg";
export { ForwardRef as ReactComponent };